import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {RecurringType} from "../../../commons/types/recurring.type";

const RECURRING_OPTIONS: RecurringType[] = [RecurringType.DAILY, RecurringType.WEEKLY];

export class PricePlanDeliveryDaysScheduleComponent implements IController {
  eventSchedule: any;
  onRecurringChange: Function;
  onChange: Function;

  public days: any;
  public hasSelectedDay: boolean;
  public recurringOptions: RecurringType[] = RECURRING_OPTIONS;
  public recurringTypes: typeof RecurringType = RecurringType;

  constructor(private commonsConstants) {
  }

  $onChanges() {
    this.setDays();
  }

  onRecurringSelect(type: RecurringType) {
    // Backend turns DAILY + byWeekDay into FREQ=DAILY;BYDAY=..., so stale days would still restrict delivery
    if (type === RecurringType.DAILY && this.eventSchedule) {
      this.eventSchedule.byWeekDay = [];
      this.setDays();
    }
    this.onRecurringChange({type});
  }

  onDayChange(dayKey: string, isEnable: boolean) {
    if (!isEnable) {
      if (!this.eventSchedule.byWeekDay) {
        this.eventSchedule.byWeekDay = [];
      }
      this.eventSchedule.byWeekDay.push(dayKey);
    } else {
      const index = this.eventSchedule.byWeekDay.indexOf(dayKey);
      this.eventSchedule.byWeekDay.splice(index, 1);
    }

    this.hasSelectedDay = !!this.eventSchedule.byWeekDay.length;
    this.onChange();
  }

  private setDays() {
    this.days = angular.copy(this.commonsConstants.daysCheckboxConfig);

    _.forOwn(this.days, (value, key) => {
      value.enabled = _.includes(this.eventSchedule?.byWeekDay, key);
    });

    this.hasSelectedDay = _.some(this.days, 'enabled');
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .component('pricePlanDeliveryDaysSchedule', {
    bindings: {
      eventSchedule: '<',
      onRecurringChange: '&',
      onChange: '&'
    },
    template: require('./price-plan-delivery-days-schedule.html').default,
    controller: PricePlanDeliveryDaysScheduleComponent
  });
